import { useQuery } from '@tanstack/react-query';
import {
  applyScenario,
  resourceState,
  shouldRetryMarketing,
  toMarketingError,
  type AudienceSegment,
  type ResourceState,
} from '@/features/marketing-shared';
import { emailMarketingKeys, fetchEmailAudiences } from '../api/email-marketing-api';
import { useEmailMarketing } from './context';

/**
 * Públicos que a loja pode escolher no wizard: as segmentações já resolvidas,
 * com a partição por consentimento, descadastro e e-mail inválido calculada
 * pela API para o canal.
 */
export function useEmailAudiences(): { audiences: AudienceSegment[]; state: ResourceState } {
  const { idPassbook, scenario } = useEmailMarketing();
  const query = useQuery({
    queryKey: emailMarketingKeys.audiences(idPassbook ?? 'platform'),
    queryFn: () => fetchEmailAudiences(idPassbook!),
    enabled: Boolean(idPassbook),
    retry: shouldRetryMarketing,
    staleTime: 60_000,
  });
  const applied = applyScenario(query.data ?? [], resourceState(query, toMarketingError), scenario);
  return { audiences: applied.items, state: applied.state };
}
